namespace Matrix.Data {
    export interface DataReportListSheetsRequest extends Serenity.ServiceRequest {
        TemplateKey?: string;
    }
}
